import { faChartLine, faScrewdriverWrench, faServer, faUserPlus } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { getSession } from "../utils/utils";
import { useEffect, useState } from "react";

import HomeCardLayout from "../layouts/HomeCardLayout";

function OpcionesInicio() {
    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState({
        email: null,
        name: null,
        company: null,
        role: null
    });

    async function getInfo() {
        let session = await getSession();
        
        if (session !== null) {
            setUserInfo(session);
            return;
        }

        navigate("/");

        return;
    }

    useEffect(function () {
        getInfo();
    }, []);

    return (
        <div className="pt-4 px-4 w-full flex items-center h-full">
            <div className="flex flex-wrap w-full">
                <div className="w-full md:w-1/2 p-2">
                    <HomeCardLayout
                        icon={faUserPlus}
                        link="/DatosTrabajador"
                        title="Formulario"
                        description="Registrar a nuevos usuarios del servicio"
                        button="Iniciar Registro"
                    />
                </div>
                <div className="w-full md:w-1/2 p-2">
                    <HomeCardLayout
                        icon={faServer}
                        link="/CargaMasiva"
                        title="Carga Masiva"
                        description="Puedes subir una base de datos completa"
                        button="Iniciar Subida"
                        // allowed={false}
                    />
                </div>
                <div className="w-full md:w-1/2 p-2">
                    <HomeCardLayout
                        icon={faChartLine}
                        link="/Dashboard"
                        title="Dashboard"
                        description="Visualiza los datos de las CAPIS"
                        button="Ingresar"
                    />
                </div>
                {(userInfo.role === "Admin" || userInfo.role === "Empresa") && (
                    <div className="w-full md:w-1/2 p-2">
                        <HomeCardLayout
                            icon={faScrewdriverWrench}
                            link="/Mantenimiento"
                            title="Mantenimiento"
                            description={(userInfo.role === "Admin") ? "CAPIS y Contraseñas" : "Sucursales y Colaboradores"}
                            button="Ingresar"
                        />
                    </div>
                )}
            </div>
        </div>)
}

export default OpcionesInicio;